import React from "react";
import { Route } from "react-router-dom";
import InvoiceRoute from "./invoice";
import OfferingRoutes from "./offering";
import PaymentRoutes from "./payment";
import PurchaseOrderRoutes from "./purchase-order";
import PurchaseRecapRoutes from "./purchase-recap";
import PurchaseRequestRoutes from "./purchase-request";
import PurchaseReturnRoutes from "./purchase-return";
import QuotationRoutes from "./quotation";
import ReceivingRoutes from "./receiving";

export default function PurchasingRoutes( props ) {
    return (
    <Route path="/purchasing">
       {InvoiceRoute(props)}
       {PaymentRoutes(props)}
       {OfferingRoutes(props)}
       {PurchaseRequestRoutes(props)}
       {PurchaseReturnRoutes(props)}
       {PurchaseRecapRoutes(props)}
       {PurchaseOrderRoutes(props)}
       {QuotationRoutes(props)}
       {ReceivingRoutes(props)}
    </Route>
    )
}